import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20illustration%20style%2C%20dramatic%20composition%20with%20soft%20teal%20and%20warm%20orange%20tones%2C%20abstract%20ink%20wash%20background%20with%20flowing%20lines%2C%20dynamic%20energy%2C%20modern%20digital%20art%20aesthetic%2C%20dark%20atmospheric%20mood%20with%20warm%20highlights%2C%20painterly%20texture%2C%20cinematic%20lighting%2C%20no%20text&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="炮渣漫画网 - 韩国漫画大全"
        title="韩国漫画大全 - 炮渣漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-6 md:px-10">
        <div className="max-w-[640px]">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6">
            韩国漫画大全
            <br />
            最新热门推荐
            <br />
            无删减排行榜
          </h1>

          <div className="flex flex-col md:flex-row gap-4 md:gap-8 mt-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-5 py-3">
              <p className="text-white/80 text-xs mb-1">海量资源</p>
              <p className="text-white font-semibold text-sm">5000+ 部漫画</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-5 py-3 md:mt-6">
              <p className="text-white/80 text-xs mb-1">每日更新</p>
              <p className="text-white font-semibold text-sm">30+ 新章节</p>
            </div>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/action"
              className="inline-flex items-center justify-center bg-primary-500 hover:bg-primary-600 text-white font-medium px-7 py-3.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center border border-white/30 hover:border-white/60 text-white font-medium px-7 py-3.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}